/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ModeloClasesTecnicas from 'Infotrack@Modelos/smartStock/clasesTecnicas';
import IClasesTecnicas from 'Infotrack@Modelos/smartStock/clasesTecnicas/entidades/clasesTecnicas';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import IFiltrosClasesTecnicas from 'Infotrack@Modelos/smartStock/clasesTecnicas/entidades/filtrosClasesTecnicas';

export default class ControladorModeloClasesTecnicas {
    private modeloClasesTecnicas: ModeloClasesTecnicas;
    constructor() {
        this.modeloClasesTecnicas = new ModeloClasesTecnicas();
    }

    public consultarClasesTecnicas() {
        return this.modeloClasesTecnicas.consultarClasesTecnicas().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearClasesTecnicas(clasesTecnicas: IClasesTecnicas) {
        await this.modeloClasesTecnicas.crearClasesTecnicas(clasesTecnicas);
    }

    public async editarClasesTecnicas(clasesTecnicas: IClasesTecnicas) {
        await this.modeloClasesTecnicas.editarClasesTecnicas(clasesTecnicas);
    }
    public async eliminarClasesTecnicas(clasesTecnicas: IClasesTecnicas) {
        await this.modeloClasesTecnicas.eliminarClasesTecnicas(clasesTecnicas);
    }

    public validarEntidad(clasesTecnicas: IClasesTecnicas): boolean {
        if (clasesTecnicas.ClaseTecnicaDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarClasesTecnicasPorFiltro(filtrosClasesTecnicas: IFiltrosClasesTecnicas) {
       return (await this.modeloClasesTecnicas.consultarListaClasesTecnicasPorFiltro(filtrosClasesTecnicas)).data.Entidades;
    }
}
